"use client";

import * as Sentry from "@sentry/nextjs";
import { useEffect } from "react";

import Content from "@/components/site/Content";
import { Button } from "@/components/ui/Button";
import { Card } from "@/components/ui/Card";
import { LinkButton } from "@/components/ui/LinkButton";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error(error);
    Sentry.captureException(error);
  }, [error]);

  return (
    <Content className="space-y-4">
      <h1 className="section-title text-fg">Something went wrong</h1>
      <Card className="p-6 space-y-3">
        <p className="text-sm text-[hsl(var(--fg)/0.70)]">
          We&apos;ve logged the error. You can try again, or head back home.
        </p>
        <div className="flex items-center gap-3">
          <Button onClick={() => reset()} className="shrink-0 font-semibold">
            Try again
          </Button>
          <LinkButton href="/" variant="outline" className="shrink-0">
            Go to homepage
          </LinkButton>
        </div>
      </Card>
    </Content>
  );
}
